import React, { useState, useEffect } from 'react';
import { Row, Col, message } from 'antd';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ListCard from 'Molecules/ListCard';
import Search from './components/Search';
import { getAvailableProducts } from '../../../../../ducks/actions';
import { updateDiscountProductList } from '../../../../../ducks/services';
import { useTranslate } from 'Translate';

const filters = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Active',
    value: 'active',
  }
];

export default (props) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { activeTab, data, reloadApi, allowedEdit, allowedDelete } = props;
  const [filterVal, setFilterVal] = useState(filters[0]?.value);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchVal, setSearchVal] = useState(null);
  const availableProduct = useSelector((state) => state.pos.discountAvProducts);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const i18n = useTranslate();
  const { t } = i18n;

  // products
  const ListCol2 = [
    {
      title: t("Outlet.product_code"),
      dataIndex: 'code',
      key: 'code',
      sorter: true,
    },
    {
      title: t("Product.product_name"),
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    }
  ];

  const rowClassName = (record, index) => {
    // discount to return product_ids (discount_products.where(is_blocked: false, status: :active).pluck(:product_id))
    return data?.allowed_product_ids?.some(x => x === record?.id) ? 'highlight-row' : '';
  };

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getAvailableProducts(filterVal, pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading, id));
    } else {
      dispatch(getAvailableProducts(filterVal, pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading, id));
    }
  };

  const onSearch = (search) => {
    if (search) {
      let searchVal = {};
      searchVal = {
        product: search.name
      };
      setSearchVal(searchVal);
      dispatch(getAvailableProducts(filterVal, page, limit, '', '', searchVal, props.setLoading, id));
    } else {
      setSearchVal(null);
      dispatch(getAvailableProducts(filterVal, page, limit, '', '', null, props.setLoading, id));
    }
  };

  useEffect(() => {
    if (activeTab === "4") {
      setPage(1);
      dispatch(getAvailableProducts(filterVal, 1, limit, '', '', searchVal, props.setLoading, id));
    }
  }, [activeTab, filterVal]);

  const onFilter = (e) => {
    setFilterVal(e.target.value);
  };

  const btnList = [
    {
      title: t("Confirm.allow_selected_products"),
      text: 'Allow',
      action: () => onUpdateList("allow"),
      classes: 'green-btn',
      permit: true,
      placement: "leftTop"
    },
    {
      title: t("Confirm.remove_selected_products"),
      text: 'Remove',
      action: () => onUpdateList("remove"),
      classes: 'red-btn',
      permit: true,
      placement: "leftTop"
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onUpdateList = async (status) => {
    props.setLoading(true);

    const payload = {
      discount_id: id,
      status: status,
      products: JSON.stringify(selectedRowKeys)
    }
    await updateDiscountProductList(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_listing"));
        rowSelection.onChange([]);
        reloadApi();
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <Row gutter={[20, 30]}>
      <Col span={24}>
        <HeadingChip title={t("General.discount_filters")} btnList={allowedEdit && btnList} btnHidden={selectedRowKeys.length <= 0} />
      </Col>
      <Col span={24}>
        <ListCard
          Search={Search}
          onSearch={onSearch}
          filters={filters}
          filterValue={filterVal}
          onFilter={onFilter}
          onChange={onTableChange}
          rowClassName={rowClassName}
          ListCol={ListCol2}
          ListData={availableProduct?.list?.map(x => ({ ...x, key: x.id }))}
          rowSelection={allowedEdit && rowSelection}
          pagination={{
            total: availableProduct?.total_count,
            current: page,
            pageSize: limit,
          }}
        />
      </Col>
    </Row>
  );
};
